import { Divider, Stack } from '@mui/material'
import { useGetProjectProjectFeatures } from '@/service-library/hooks/project-project-features'
import { useProjectContext } from '@/components/project-tables/ProjectProvider'
import TopBarNavigation from '@/components/top-bar-portal/TopBarNavigation'
import FileUploadButton from '@/components/upload-files/FileUploadButton'
import { useFileUploadContext } from '@/components/upload-files/FileUploadProvider'
import DownloadExportButton from '@/components/workflows/DownloadExportButton'
import { useSelectedWorkflowContext } from '../workflows/SelectedWorkflowProvider'
import ProjectIndicators from './ProjectIndicators'
import WorkflowSelector from './WorkflowSelector'
import WorkflowTabs from './WorkflowTabs'

export default function Navigation() {
  const { project } = useProjectContext()

  const { handleFilesSelectedToUpload } = useFileUploadContext()

  const { selectedWorkflow } = useSelectedWorkflowContext()

  const { projectProjectFeatures } = useGetProjectProjectFeatures({
    filters: {
      project_id: project.id,
      project_feature_id: 'd88ee57e-ff1b-4929-9215-51ff79a07db8', // Multiple Workflows feature
      limit: '1',
    },
  })
  const allowsMultipleWorkflows = projectProjectFeatures.length > 0

  if (!selectedWorkflow) return null

  return (
    <TopBarNavigation>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          px: allowsMultipleWorkflows ? 0.5 : 0.75,
          pr: 1,
          pb: 0.5,
          position: 'relative',
        }}
        spacing={1}
      >
        {allowsMultipleWorkflows && (
          <>
            <Stack direction="row">
              <WorkflowSelector />
            </Stack>
            <Divider sx={{ height: 16 }} orientation="vertical" />
          </>
        )}

        <WorkflowTabs />

        <div style={{ flexGrow: 1 }} />

        <ProjectIndicators />
        <DownloadExportButton projectId={project.id} />
        <FileUploadButton multiple onFileUpload={handleFilesSelectedToUpload} />
      </Stack>
    </TopBarNavigation>
  )
}
